export var TeamliveSettingsAuditRoutes = {
    "/tl-settings-audit": {
        "url": "/tl-settings-audit",
        "name": "appLayout.schedule.tl-settings-audit",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./teamlive-settings-audit.module.js");
                }
            }
        ]
    },
}